/** Format integer USD cents as a currency string, e.g. 30000 → "$300.00". */
export function formatUsd(cents: number): string {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(cents / 100);
}
